import { getStaffScopedApiPrefixOrCareAdvisor } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import {
  CareCoordinationReport,
  CreateCareCoordinationReportBenefitsNavigationParams,
  CreateCareCoordinationReportInternalNoteParams,
  CreateCareCoordinationReportMediaParams,
  CreateCareCoordinationReportNotesParams,
  ObjectType,
} from './types/types';

export const addCareCoordinationReportObject = async (
  care_coordination_report_id: string,
  object_type: ObjectType,
  payload:
    | CreateCareCoordinationReportInternalNoteParams
    | CreateCareCoordinationReportBenefitsNavigationParams
    | CreateCareCoordinationReportNotesParams
    | CreateCareCoordinationReportMediaParams,
  userRole?: string,
): Promise<CareCoordinationReport> => {
  const prefix = getStaffScopedApiPrefixOrCareAdvisor(userRole);
  const { data } = await client.post<CareCoordinationReport>(
    `${prefix}/care_coordination_reports/${care_coordination_report_id}/${object_type}`,
    payload,
  );

  return data;
};
